<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click.native="openDialog"
      >
        <v-icon>add_circle_outline</v-icon>
      </v-btn>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >

        <v-card>
          <v-toolbar
            card
            dense
            color="primary"
          >

            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon color="white">library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon color="white">save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon color="white">add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon color="white">delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon color="white">first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon color="white">keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon color="white">keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon color="white">last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon color="white">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click.native="close"
            >
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <contact-tabs
              ref="contacttabs"
              v-bind="dialogData"
            ></contact-tabs>
          </v-card-text>

          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      :search="search"
      class="elevation-1"
      default-sort="contactID:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <!-- <td class="text-xs-left">{{ props.item.businessAccount }}</td>
        <td class="text-xs-left">{{ props.item.owner }}</td> -->
        <td>{{ props.item.firstName }}</td>
        <td class="text-xs-left">{{ props.item.lastName }}</td>
        <!-- <td class="text-xs-left">{{ props.item.workGroup }}</td>
        <td class="text-xs-left">{{ props.item.contactClass }}</td> -->
        <td class="text-xs-left">{{ props.item.jobTitle }}</td>
        <td class="text-xs-left">{{ props.item.statusCode }}</td>
        <td class="text-xs-left">{{ props.item.type }}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getContacts, getContact, getOwner, getCountries, getStates, createContact, updateContact, deleteContact } from '@/api/contact';
//import { getBlisterScrapMasters, getBlisterScrapMaster, createBlisterScrapMaster, updateBlisterScrapMaster, deleteBlisterScrapMaster } from '@/api/scrapMaster';
import ContactTabs from '@/pages/contact/ContactTabs';
import GlobalMessage from '@/constant'
export default {
  components: {
    ContactTabs,
  },
  data: () => ({

    dialog: false,
    dialogData: null,
    loader: false,
    deleteloader: false,
    search: '',

    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      // { text: 'Business Account', value: 'businessAccount', align: 'left' },
      // { text: 'Owner', value: 'owner', align: 'left' },
      { text: 'First Name', value: 'firstName', align: 'left' },
      { text: 'Last Name', value: 'lastName', align: 'left' },
      // { text: 'Work Group', value: 'workGroup', align: 'left' },
      // { text: 'Contact Class', value: 'contactClass', align: 'left' },
      { text: 'Job Title', value: 'jobTitle', align: 'left' },
      { text: 'Status', value: 'statusCodeID', align: 'left' },
      { text: 'Type', value: 'type', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    businessAccountOptions: [
      {
        id: 1,
        name: 'Business Account 1'
      },
      {
        id: 2,
        name: 'Business Account 2'
      },
      {
        id: 3,
        name: 'Business Account 3'
      }
    ],

    workGroupOptions: [
      {
        id: 1,
        name: 'Work Group 1'
      },
      {
        id: 2,
        name: 'Work Group 2'
      },
      {
        id: 3,
        name: 'Work Group 3'
      }
    ],
    contactClassOptions: [
      {
        id: 1,
        name: 'Contact Class 1'
      },
      {
        id: 2,
        name: 'Contact Class 2'
      },
      {
        id: 3,
        name: 'Contact Class 3'
      }

    ],

    statusOptions: [
      {
        id: 1,
        name: 'Active'
      },
      {
        id: 2,
        name: 'In Active'
      },
    ],

    typeOptions: [
      {
        id: 1,
        name: 'Type 1'
      },
      {
        id: 2,
        name: 'Type 2'
      },
    ],

    gridItems: [],
    stateOptions: [],
    countryOptions: [],
    ownerOptions: [],
    // plasticbagsitems: [],
    // blisterTypeitems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      valid: false,
      contactID: -1,
      businessAccount: -1,
      owner: -1,
      firstName: '',
      lastName: '',
      workGroup: -1,
      contactClass: -1,
      jobTitle: '',
      status: -1,
      type: -1,
      email: '',
      phone: '',
      fax: '',
      address1: '',
      address2: '',
      city: '',
      stateID: -1,
      countryID: -1,
      postalCode: '',
      isDataPrivacy: '',
      dateOfConsent: '',
      consentExpires: '',
      contactMethod: -1,
      accountReference: '',
      parentAccount: '',
      inComingActivity: '',
      outGoingActivity: '',
      companyName: '',
      dOB: new Date(),
      spouseName: '',
      gender: '',
      maritalStatus: '',
      lastAccessDate: '',
      addedByUserId: this.$store.state.auth.userId,
      addedDate: new Date(),
      statusCodeId: 1,
      statusCode: 'Active',
      modifiedByUserId: this.$store.state.auth.userId,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      contactActivities: [],
      //contactDetail: [],
      contactCases: []
      //   blisterAllowable: []

    },

    defaultItem: {
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      valid: false,
      contactID: -1,
      businessAccount: -1,
      owner: -1,
      firstName: '',
      lastName: '',
      workGroup: -1,
      contactClass: -1,
      jobTitle: '',
      status: -1,
      type: -1,
      email: '',
      phone: '',
      fax: '',
      address1: '',
      address2: '',
      city: '',
      stateID: -1,
      countryID: -1,
      postalCode: '',
      isDataPrivacy: '',
      dateOfConsent: '',
      consentExpires: '',
      contactMethod: -1,
      accountReference: '',
      parentAccount: '',
      inComingActivity: '',
      outGoingActivity: '',
      companyName: '',
      dOB: new Date(),
      spouseName: '',
      gender: '',
      maritalStatus: '',
      lastAccessDate: '',
      addedByUserId: this.$store.state.auth.userId,
      addedDate: new Date(),
      statusCodeId: 1,
      statusCode: 'Active',
      modifiedByUserId: this.$store.state.auth.userId,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      contactActivities: [],
      //contactDetail: [],
      contactCases: []
      //   blisterScrapLine: [],
      //   blisterAllowable: []

    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: '....' },
      // { title: 'Post' },
      // { title: 'Delete' },
      { title: 'Print' }
    ],

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Contact' : 'Edit Contact';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {

    initialize () {
      this.loader = true;
      getContacts('')
        .then(response => {
          this.gridItems = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getOwner('')
        .then(response1 => {
          this.ownerOptions = response1.data;
          this.$refs.contacttabs.ownerOptions = this.ownerOptions;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getCountries('')
        .then(response2 => {
          this.countryOptions = response2.data;
          this.$refs.contacttabs.$refs.contactdetail.countryOptions = this.countryOptions;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getStates('')
        .then(response3 => {
          this.stateOptions = response3.data;
          this.$refs.contacttabs.$refs.contactdetail.stateOptions = this.stateOptions;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    editItem (item) {

      item.dateOfConsent = new Date(item.dateOfConsent).toISOString().substr(0, 10);
      item.consentExpires = new Date(item.consentExpires).toISOString().substr(0, 10);
      item.dOB = new Date(item.consentExpires).toISOString().substr(0, 10);
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.date = new Date().toISOString().substr(0, 10);
      this.editedItem.loginUser = 'Arun';
      this.editedItem.isLogin = 'yes-1';
      this.$refs.contacttabs.form = this.editedItem;
      //console.log(this.editedItem);
      this.$refs.contacttabs.$refs.contactdetail.form = this.editedItem;
      // this.$refs.contacttabs.$refs.contactdetail.initialize();

      this.$refs.contacttabs.$refs.contactactivities.contactID = this.editedItem.contactID;
      this.$refs.contacttabs.$refs.contactactivities.initialize();

      this.$refs.contacttabs.$refs.contactcases.contactID = this.editedItem.contactID;
      this.$refs.contacttabs.$refs.contactcases.initialize();

      this.dialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteContact(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {
      getContact(this.searchItem)
        .then(response => {
          if (response.data.contactID != null) {
            this.editedItem = response.data;
            this.editedItem.date = new Date().toISOString().substr(0, 10);
            this.editedItem.loginUser = 'Arun';
            this.editedItem.isLogin = 'yes-1';
            //this.$refs.contacttabs.$refs.contactdetail.form = this.editedItem;
            this.$refs.contacttabs.$refs.contactdetail.form = this.editedItem;
            // this.$refs.contacttabs.$refs.contactdetail.contactID = this.editedItem.contactID;
            // this.$refs.contacttabs.$refs.contactdetail.initialize();

            // this.$refs.contacttabs.$refs.contactactivities.contactID = this.editedItem.contactID;
            // this.$refs.contacttabs.$refs.contactactivities.initialize();

            // this.$refs.contacttabs.$refs.contactcases.contactID = this.editedItem.contactID;
            // this.$refs.contacttabs.$refs.contactcases.initialize();

            let index = this.gridItems.map(item => item.contactID).indexOf(response.data.contactID)
            this.editedIndex = index;
          }
          else {
           window.getApp.$emit('APP_API_SUCCESS', 'No more record to view');
          }
        })
        .catch(error => {
          // this.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.contactID;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.contactID;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.contactID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.contactID;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    openDialog () {
      this.add();
      this.dialog = true;
    },
    add () {
      this.editedItem.contactID = -1;
      this.editedItem.valid = false;
      this.editedItem.date = new Date().toISOString().substr(0, 10);
      this.editedItem.loginUser = 'Arun';
      this.editedItem.isLogin = 'yes-1';
      this.editedItem.businessAccount = null;
      this.editedItem.owner = null;
      this.editedItem.firstName = '';
      this.editedItem.lastName = '';
      this.editedItem.workGroup = null
      this.editedItem.contactClass = null;
      this.editedItem.jobTitle = '';
      this.editedItem.status = null;
      this.editedItem.type = null;
      this.editedItem.email = '';
      this.editedItem.phone = '';
      this.editedItem.fax = '';
      this.editedItem.address1 = '';
      this.editedItem.address2 = '';
      this.editedItem.city = '';
      this.editedItem.stateID = null;
      this.editedItem.countryID = null;
      this.editedItem.postalCode = '';
      this.editedItem.isDataPrivacy = '';
      this.editedItem.dateOfConsent = new Date().toISOString().substr(0, 10);
      this.editedItem.consentExpires = new Date().toISOString().substr(0, 10);
      this.editedItem.contactMethod = null;
      this.editedItem.accountReference = '';
      this.editedItem.parentAccount = '';
      this.editedItem.inComingActivity = '';
      this.editedItem.outGoingActivity = '';
      this.editedItem.companyName = '';
      this.editedItem.dOB = new Date().toISOString().substr(0, 10);
      this.editedItem.spouseName = '';
      this.editedItem.gender = null;
      this.editedItem.maritalStatus = null;
      this.editedItem.lastAccessDate = '';
      this.editedItem.addedByUserId = this.$store.state.auth.userId;
      this.editedItem.addedDate = new Date();
      this.editedItem.statusCodeID = null;
      this.editedItem.statusCode = 'Active';
      this.editedItem.modifiedByUserId = this.$store.state.auth.userId;
      this.editedItem.modifiedDate = new Date();
      this.editedItem.contactactivities = [];
      this.$refs.contacttabs.$refs.contactdetail.form = this.editedItem;

      // this.$refs.contacttabs.$refs.contactdetail.contactID = this.editedItem.contactID;
      // this.$refs.contacttabs.$refs.contactdetail.contactactivities = [];
      this.$refs.contacttabs.$refs.contactactivities.contactID = -1;
      this.$refs.contacttabs.$refs.contactactivities.gridItems = [];
      this.$refs.contacttabs.$refs.contactcases.contactID = -1;
      this.$refs.contacttabs.$refs.contactcases.gridItems = [];
      this.$refs.contacttabs.$refs.contactdetail.countryOptions = this.countryOptions;
      this.$refs.contacttabs.$refs.contactdetail.stateOptions = this.stateOptions;
      this.$refs.contacttabs.ownerOptions = this.ownerOptions;
      this.editedIndex = -1;
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      this.deleteloader = true;
      let index = this.editedIndex;

      deleteContact(this.$refs.contacttabs.$refs.contactdetail.form)
        .then(() => {
          this.$refs.contacttabs.$refs.contactdetail.loader = false;
          this.deleteloader = false;
          this.add();
          this.gridItems.splice(index, 1);
         window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.deleteloader = false;
          this.$refs.contacttabs.$refs.contactdetail.loader = false;
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save () {
      this.editedItem = this.$refs.contacttabs.$refs.contactdetail.form;
      console.log(this.editedItem);
      //this.editedItem.contactdetail = this.$refs.contacttabs.$refs.contactdetail.form;
      //this.editedItem = this.$refs.contacttabs.$refs.contactdetail.form;
      // this.editedItem.contacttabs = this.$refs.contacttabs.$refs.contactdetail;
      this.editedItem.contactactivities = this.$refs.contacttabs.$refs.contactactivities.gridItems;
      this.editedItem.contactcases = this.$refs.contacttabs.$refs.contactcases.gridItems;

      // this.$refs.contacttabs.$refs.contactdetail.loader = true;
      if (this.$refs.contacttabs.$refs.contactlist.validate()) {

        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserId = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateContact(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              this.loader = false;
             window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);

            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
              //this.$refs.contacttabs.$refs.contactdetail.loader = false;
            });
        } else {
          this.editedItem.contactID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          createContact(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;              
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.contactID).indexOf(response.data.contactID)
              this.editedIndex = index;
             window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
             window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
      else {
        console.log('Validation failed.')
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/contact/ContactList.vue